import React from 'react';
import { useAppStore } from '@/lib/store';
import { formatIST } from '@/utils/format';

export default function MemoryModal() {
  const { memoryModal, closeMemoryModal } = useAppStore();
  const { isOpen, memory } = memoryModal;

  if (!isOpen || !memory) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4" onClick={closeMemoryModal}>
      <div
        className="bg-[#2b2c2f] border border-[#515153] rounded-xl w-full max-w-lg shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-[#3e3f42]">
          <div>
            <h2 className="text-[15px] font-semibold text-[#d5d6d9]">Memory</h2>
            <p className="text-[12px] text-[#8f9196] mt-0.5">
              {memory.category || 'fact'} · {memory.createdAt ? formatIST(memory.createdAt) : ''}
            </p>
          </div>
          <button onClick={closeMemoryModal} className="text-[#8f9196] hover:text-white p-1">
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
          </button>
        </div>
        <div className="px-5 py-4">
          <div className="bg-[#1d1e22] border border-[#3e3f42] rounded-lg p-4 text-[14px] text-[#d5d6d9] leading-relaxed whitespace-pre-wrap min-h-[80px]">
            {memory.content}
          </div>
          {memory.summary && (
            <div className="mt-3 text-[12px] text-[#8f9196]">
              <span className="font-medium text-[#b3b4b7]">Summary: </span>{memory.summary}
            </div>
          )}
        </div>
        <div className="px-5 py-3 border-t border-[#3e3f42] flex justify-end">
          <button onClick={closeMemoryModal} className="px-4 py-1.5 text-[13px] text-[#8f9196] hover:text-white border border-[#515153] rounded-md transition-colors">
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
